'use client';

import { cn } from '../../../libs/utils';
import { Svg } from '../../common';
import { TextField, TextFieldProps } from '../../index';

interface SelectProps extends TextFieldProps {
  selectedValue: string;
  isHideIcon?: boolean;
}

export const Select = ({ onClick, className, placeholder, isHideIcon, selectedValue, ...props }: SelectProps) => {
  const { disabled, trailingElement } = props;

  const getTrailingElement = () => {
    if (isHideIcon) return null;
    if (trailingElement) {
      return trailingElement;
    }
    return (
      <div className="flex h-6 w-6 items-center justify-center">
        <Svg src="ic_chevron-down.svg" width={16} height={16} />
      </div>
    );
  };

  return (
    <TextField
      inputMode="none"
      type="button"
      className={cn(
        {
          'cursor-pointer': !disabled,
          '*:text-neutral-foreground-low': !!selectedValue && disabled,
          '*:!text-neutral-foreground-disabled': !selectedValue && placeholder && disabled,
          '*:text-neutral-foreground-lowest': !selectedValue && !(placeholder && disabled)
        },
        className
      )}
      onClick={onClick}
      defaultValue={selectedValue || placeholder}
      trailingElement={getTrailingElement()}
      {...props}
    />
  );
};
